import request from '@/utils/request'

// 查询【请填写功能名称】列表
export function listShow(url,query) {
  return request({
    url: url+'/divisionShow/list',
    method: 'get',
    params: query
  })
}

// 查询【请填写功能名称】详细
export function getShow(url,id) {
  return request({
    url: url+'/divisionShow/' + id,
    method: 'get'
  })
}

// 新增【请填写功能名称】
export function addShow(url,data) {
  return request({
    url: url+'/divisionShow',
    method: 'post',
    data: data
  })
}

// 修改【请填写功能名称】
export function updateShow(url,data) {
  return request({
    url: url+'/divisionShow',
    method: 'put',
    data: data
  })
}

// 删除【请填写功能名称】
export function delShow(url,id) {
  return request({
    url: url+'/divisionShow/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/work/show.js